import { createFileRoute } from '@tanstack/react-router';
import AuthGuard from '@/components/auth-guard';
import { BudgetManagementSimple } from '@/components/dashboard/budget-management-simple';

export const Route = createFileRoute('/budgets')({
  component: BudgetsPage,
});

function BudgetsPage() {
  return (
    <AuthGuard requireAuth={true}>
      <div className="container mx-auto space-y-6 px-4 py-6">
        <div>
          <h1 className="font-bold text-2xl tracking-tight">
            Gerenciamento de Orçamentos
          </h1>
          <p className="text-muted-foreground">
            Gerencie seus orçamentos mensais e acompanhe seus gastos
          </p>
        </div>

        <BudgetManagementSimple />
      </div>
    </AuthGuard>
  );
}
